module.exports = __webpack_public_path__ + "img/recruit_banner.c66593c0.png";